/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BoardReportDto
 */
export interface BoardReportDto {
    /**
     * 
     * @type {string}
     * @memberof BoardReportDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardReportDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardReportDto
     */
    profileId?: string;
    /**
     * 
     * @type {Date}
     * @memberof BoardReportDto
     */
    generatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof BoardReportDto
     */
    generatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardReportDto
     */
    reportPeriod?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardReportDto
     */
    priorSnapshotId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BoardReportDto
     */
    firstReport?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof BoardReportDto
     */
    reportData?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof BoardReportDto
     */
    humanReviewedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof BoardReportDto
     */
    humanReviewedBy?: string;
}

/**
 * Check if a given object implements the BoardReportDto interface.
 */
export function instanceOfBoardReportDto(value: object): value is BoardReportDto {
    return true;
}

export function BoardReportDtoFromJSON(json: any): BoardReportDto {
    return BoardReportDtoFromJSONTyped(json, false);
}

export function BoardReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoardReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'generatedAt': json['generatedAt'] == null ? undefined : (new Date(json['generatedAt'])),
        'generatedBy': json['generatedBy'] == null ? undefined : json['generatedBy'],
        'reportPeriod': json['reportPeriod'] == null ? undefined : json['reportPeriod'],
        'priorSnapshotId': json['priorSnapshotId'] == null ? undefined : json['priorSnapshotId'],
        'firstReport': json['firstReport'] == null ? undefined : json['firstReport'],
        'reportData': json['reportData'] == null ? undefined : json['reportData'],
        'humanReviewedAt': json['humanReviewedAt'] == null ? undefined : (new Date(json['humanReviewedAt'])),
        'humanReviewedBy': json['humanReviewedBy'] == null ? undefined : json['humanReviewedBy'],
    };
}

export function BoardReportDtoToJSON(json: any): BoardReportDto {
    return BoardReportDtoToJSONTyped(json, false);
}

export function BoardReportDtoToJSONTyped(value?: BoardReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'profileId': value['profileId'],
        'generatedAt': value['generatedAt'] == null ? undefined : ((value['generatedAt']).toISOString()),
        'generatedBy': value['generatedBy'],
        'reportPeriod': value['reportPeriod'],
        'priorSnapshotId': value['priorSnapshotId'],
        'firstReport': value['firstReport'],
        'reportData': value['reportData'],
        'humanReviewedAt': value['humanReviewedAt'] == null ? undefined : ((value['humanReviewedAt']).toISOString()),
        'humanReviewedBy': value['humanReviewedBy'],
    };
}

